import { render, staticRenderFns } from "./AssetsMortgage.vue?vue&type=template&id=03b50c58"
import script from "./AssetsMortgage.vue?vue&type=script&lang=js"
export * from "./AssetsMortgage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports